<div class="titulo-receber-view-container">
    <div class="container-header">
        <nav class="container-header-block container-header-breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">Títulos a Receber</li>
            </ol>
        </nav>

        <div class="container-header-block container-header-options">
            <button type="button" class="btn btn-primary mr-2" (click)="insert()" *ngIf="config?.canInsert"><i class="fas fa-plus" aria-hidden="true"></i> Novo</button>

            <!-- Opções -->
            <div class="btn-group" *ngIf="options?.hasAnyOption()">
                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="d-none d-xl-inline-block">Opções</span>
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" *ngIf="options?.printListagem" (click)="printListagem()">
                        <i class="fas fa-print" aria-hidden="true"></i> Imprimir
                    </a>

                    <ng-template [ngIf]="options?.canImportErp_v1 || options?.canImportErp">
                        <div class="dropdown-divider"></div>
                        <h6 class="dropdown-header">Integração</h6>                        
                        <!-- Import ERP V1 -->
                        <a class="dropdown-item" *ngIf="options?.canImportErp_v1" (click)="openIntegracaoErpImportModal_v1()">
                            <i class="fas fa-download"></i> Importar do ERP
                        </a>
                        <a class="dropdown-item" *ngIf="options?.canImportErp" (click)="openIntegracaoErpImportModal()">
                            <i class="fas fa-download"></i> Importar do ERP
                        </a>
                    </ng-template>

                </div>
            </div>            
        </div>  

        <div class="container-header-block container-header-perspectiva-filter">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        Perspectiva
                    </span>
                </div>
                <div class="input-group-select">
                    <sgt-titulo-receber-perspectiva-select
                        [idPerspectiva]="filter.perspectiva"
                        (idPerspectivaChange)="onChangePerspectiva($event)"
                        [canSelectNull]="false">
                    </sgt-titulo-receber-perspectiva-select>
                </div>
                <div class="input-group-append">
                    <span class="input-group-text">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" [ngModel]="filter.agruparPorCliente" (ngModelChange)="onChangeAgruparPorCliente($event)" name="filteragruparPorCliente" id="filteragruparPorCliente">
                            <label class="custom-control-label" for="filteragruparPorCliente">Agrupar por cliente</label>
                        </div>
                    </span>
               </div>                
            </div>
        </div>
        
        <!-- <div class="container-header-block container-header-visualizacao">
            <sgt-titulo-receber-visualizacao
                #visualizacaoComponent
                [storageKey]="visualizacaoStorageKey"
                (changeModo)="onChangeModoVisualizacao()">
            </sgt-titulo-receber-visualizacao>            
        </div>           -->
    </div>  

    <div class="container-filter">
        <sgt-titulo-receber-filter
            #tituloReceberFilter
            [initialization]="filterInitialization"
            [storageKey]="filterStorageKey"
            [filter]="filter"
            (filterChange)="onFilterChange()"
            (filterCleaned)="onFilterCleaned()">
        </sgt-titulo-receber-filter>
    </div>    

    <div class="container-content">  
        <!-- Table -->
        <!-- *ngIf="visualizacaoComponent?.isModoTable()" -->

        <!-- Agrupado por cliente -->
         <ng-template [ngIf]="filter.agruparPorCliente">
             <sgt-titulo-receber-cliente-table
                #clienteTable
                [filter]="filter"
                (visualizarTitulos)="visualizarTitulosCliente($event)">
             </sgt-titulo-receber-cliente-table>
         </ng-template>

         <ng-template [ngIf]="!filter.agruparPorCliente">
             <sgt-titulo-receber-table
                 #table
                 [filter]="filter"
                 (editTitulo)="editTitulo($event)"
                 (visualizarTitulo)="visualizarTitulo($event)">
             </sgt-titulo-receber-table>
         </ng-template>         
        
        <!-- Dashboard -->  
        <!-- <sgt-titulo-receber-dashboard
            *ngIf="visualizacaoComponent?.isModoDashboard()"
            #dashboard
            [filter]="filter">
        </sgt-titulo-receber-dashboard>            -->
    </div>    
</div>

<!-- Modal de integração do títulos -->
<sgt-integration-titulo-receber-modal
    #integrationModal
    (afterExecuteIntegration)="afterImporErp_v1()">
</sgt-integration-titulo-receber-modal>

<!-- Modal para importar clientes do ERP -->
<sgt-titulo-receber-integracao-erp-import-modal
    #integracaoErpImportModal>
</sgt-titulo-receber-integracao-erp-import-modal>

<!-- Modal para visualizar os títulos de um cliente -->
 <sgt-titulo-receber-cliente-view-modal
    #clienteViewModal
    (editTitulo)="editTitulo($event)"
    (visualizarTitulo)="visualizarTitulo($event)">
 </sgt-titulo-receber-cliente-view-modal>

 <!-- Form Modal -->
  <sgt-titulo-receber-form-modal
    #formModal
    (afterInsert)="refresh()"
    (afterEdit)="refresh()">
  </sgt-titulo-receber-form-modal>